import { ITempElementManager } from '@src/slide/application/service/temp-element-manager/temp-element-manager.interface';
import { IMoveElementManager } from '@src/slide/application/service/move-element-manager/move-element-manager.interface';
import { IGuidesManager } from '@src/slide/application/service/guides-manager/index.interface';
import { IAbsorbManager } from '@src/slide/application/service/absorb-manager/absorb-manager.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { ISizeInfo } from '@src/slide/application/service/edit-action-services/element-info';
import { ISubscribableService } from '@src/slide/application/service/subscribable-service/subscribable-service.interface';
import type { DragEvent } from 'react';
import { IMultiRect } from '@src/slide/application/service/edit-action-services/edit-process/edit-process.interface';
import { MODES } from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';
import { ISnapLineService } from '@src/slide/application/service/snap-line-service/interface/snap-line-service.interface';

export interface IDragEventPayload {
    elementModel: IElementBaseModel;
    e: DragEvent;
}

export interface IDraggingEventPayload extends IDragEventPayload {
    originalSize: ISizeInfo;
    nextSize: ISizeInfo;
    multiRect: IMultiRect | null;
    mode: MODES;
}

export interface IDragStartEventPayload extends IDragEventPayload {
    originalSize: ISizeInfo | null;
}

export enum DragEventType {
    DRAGGING = 'dragging',
    DRAG_START = 'dragStart',
    DRAG_STOP = 'dragStop',
}

/**
 * 这里以 enum 作为EventMap的 key，原因是想业务的调用方式为：xx.on(DragEventType.DRAGGING)，而不是.on('dragging')
 * 虽然 SubscribableService 已经能够根据泛型，给出 eventName 的约束，但是全是字符串还是不利于维护
 * 推荐后续的其他 eventMap 也以 枚举作为 Key。SubscribableService 全部 api 将会对 EventMap 的 key 做强约束
 */
export interface DragEventMap {
    [DragEventType.DRAGGING]: IDraggingEventPayload;         // 拖拽过程
    [DragEventType.DRAG_START]: IDragStartEventPayload;      // 拖拽开始
    [DragEventType.DRAG_STOP]: IDragEventPayload;            // 拖拽结束
}

export interface IDragElementHandler extends ISubscribableService<DragEventMap> {
    handleMouseDownOnElement(event, elementModel, scale, needMouseUp, callback?: Function, callbackAfterDrag?): void;
    handleTouchStartOnElement(event, elementModel, scale, needMouseUp, callback: Function, callbackAfterDrag?): void;
    handleDragStart(elementModel, originalSize, e): void;
    handleDrag(e, originalSize, nextSize, mode): void;
    handleDragStop(mode, e): void;
    setTempElementManagerDelegate(tempElementManager: ITempElementManager): void;
    setMoveElementManagerDelegate(moveElementManager: IMoveElementManager): void;
    setGuidesManagerDelegate(guidesManager: IGuidesManager): void;
    setAbsorbManagerDelegate(absorbManager?: IAbsorbManager): void;
    setSnapLineServiceDelegate(snapLineService?: ISnapLineService): void;
}
